import { Card, CardContent } from "@/shared/ui/card";
import shape1 from "@assets/shape1.png"
import shape2 from "@assets/shape2.png"
import shape3 from "@assets/shape3.png"
import shape4 from "@assets/shape4.png"

const data = [
  {
    title: "Learns",
    image: shape4,
    text: "Understands your brand voice and tone."
  },
  {
    title: "Creates",
    image: shape3,
    text: "Writes on-brand content across every platform."
  },
  {
    title: "Adapts",
    image: shape2,
    text: "Knows what works, analyzes results, adapts instantly."
  },
  {
    title: "Evolves",
    image: shape1,
    text: "Your brand grows. siAi keeps up."
  }
];



type CardProps = {
  title: string,
  text: string,
  image: string,
}

const InfoCard = ({ image, text, title }: CardProps) => {
  return (

    <>
      <Card className="border bg-gradient-to-b from-[#2A0163] to-[#320177] border-[#6519CF] relative aspect-[5/3] lg:aspect-[5/4] w-full mx-auto">
        <span className="absolute -top-8 sm:-top-12 left-[50%] -translate-x-[50%]">
          <img className="w-full max-sm:w-32 !max-w-[30rem] animate-bounce-up-down" src={image} />
        </span>
        <CardContent className="size-full flex flex-col items-center justify-end">
          <p className="text-[#EB4B7F] font-montserrat font-semibold text-2xl">{title}</p>
          <p className="font-poppins text-center font-light text-white text-sm">{text}</p>
        </CardContent>
      </Card>
    </>
  );
}

const InformationAndWhy = () => {
  return (
    <div className="min-h-screen w-full relative overflow-hidden pt-[24vh] px-5">

      <div className="w-full flex flex-col gap-5 items-center justify-center py-5 md:pt-10 xl:pt-24">
        <h3 className="text-4xl lg:text-5xl font-montserrat text-[#390088] font-bold">Your brand team. <br /> Now automated.</h3>
        <p className="font-poppins max-w-5xl tracking-wide leading-6 text-[#2A0163] text-center text-sm sm:text-base lg:text-lg pb-10">siAi thinks like your best strategist, writes like your top copywriter, and learns like your most curious intern.</p>
        <div className="w-full max-w-6xl mx-auto py-10 grid sm:grid-cols-2 lg:grid-cols-4 min-h-[20rem] xl:min-h-[18rem] px-5 gap-y-10 gap-x-5 pt-10">
          {data.map((info, index) => (
            <InfoCard title={info.title} text={info.text} image={info.image} key={index} />
          ))}
        </div>
        <p className="font-poppins max-w-5xl tracking-wide leading-6 text-[#2A0163] text-center text-sm sm:text-base font-medium lg:text-lg pb-10">The more you work with her, the more she thinks like you.</p>
      </div>
    </div>
  ) 
}

export default InformationAndWhy;
